<template>
  <div>
 
    <div class="content content-boxed">
      
      <div v-if="dashboardFlags.evsensAdminFlag===false" class="bg-image img-rounded overflow-hidden push tesla-bg">
      </div>

      <div class="row">
        <div class="col-xs-12">

          <h1 class="h2 font-w300 push">{{ labelTopPage[actualLanguage] }}</h1>

          <div v-if = "actualBundle.permissions.bundle[0].value" class="block block-rounded">

            <div v-if = "dashboardFlags.evsensAdminFlag===false">

                <!-- Sharing section -->
                <div class="block block-bordered">
                  <div class="block block-themed">
                    <div class="block-header bg-primary-dark">
                            <ul  class="block-options">

                                <li v-if="flagDisplaySharing===0">
                                    <button type="button" @click="toggleDisplaySharing()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                                </li>

                                <li v-if="flagDisplaySharing">
                                    <button  type="button" @click="toggleDisplaySharing()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                                </li>

                            </ul>
                        <h2 class="h4 block-title" @click="toggleDisplaySharing()"><i class="fa fa-share-alt fa-1x push-5-r "></i>{{ sectionLabelSharing[actualLanguage] }}</h2>
                    </div>

                    <div v-if="flagDisplaySharing" class="block-content">
                      <div class="row">

                          <div class="col-sm-12 col-md-12 push">
                            <div>
                                <p><button v-if="bundleSharingEnableFlag" @click="shareMyDefaultBundle()" type="button" class="btn btn-block btn-success align-left" name="button">
                                  <span><i class="fa fa-share-alt fa-1x push-5-r "></i>{{ buttonLabelShareMyDefaultBundle[actualLanguage] }}</span></button></p>
                            </div> 
                          </div>

                          <div class="col-xs-12 push">
                            <h6  class="font-w200">{{ textSharingDetail[actualLanguage] }}</h6>
                          </div>

                          <div class="col-sm-12 col-md-12 push">
                            <div>
                                <p><button v-if="bundleSharingEnableFlag" @click="readGroupSharings()" type="button" class="btn btn-block btn-success align-left" name="button">
                                  <span><i class="fa fa-repeat fa-1x push-5-r "></i>{{ buttonLabelRefreshListSharing[actualLanguage] }}</span></button></p>
                            </div> 
                          </div>

                          <div class="col-xs-12 col-sm-12">
                          <div class="table-responsive">
                          <table v-if="ListOfSharings.length > 0" class="table">
                              <thead>
                                  <tr>
                                      <th class="text-center" style="width: 10%;">Type</th>
                                      <th class="text-center" style="width: 25%;">{{ tableLabelReferenceName[actualLanguage] }}</th>
                                      <th class="text-center" style="width: 20%;">{{ tableLabelSharingName[actualLanguage] }}</th>
                                      <th class="text-center" style="width: 20%;">{{ tableLabelRecipient[actualLanguage] }}</th>
                                      <th class="text-center" style="width: 10%;">{{ tableLabelStatus[actualLanguage] }}</th>
                                      <th class="text-center" style="width: 15%;">Action</th>
                                  </tr>
                              </thead>
                              <tbody>   
                                    <tr v-for="(sharing,index) in ListOfSharings">
                                        <td class="text-center">
                                          <i v-if ="sharing.sharedEntity.entityType==='Channel'" class="fa fa-television fa-2x push-5-r "></i>
                                          <i v-if ="sharing.sharedEntity.entityType==='Device'" class="fa fa-server fa-2x push-5-r "></i>
                                          <i v-if ="sharing.sharedEntity.entityType==='Bundle'" class="fa fa-usb fa-2x push-5-r "></i>
                                          <i v-if ="sharing.sharedEntity.entityType==='Group'" class="fa fa-users fa-2x push-5-r "></i>
                                          
                                        </td>
                                        <td class="text-center">
                                          <p>{{sharing.sharedEntity.entityReferenceName}}</p>
                                        </td>
                                        <td class="text-center">
                                            <p>{{sharing.sharingReferenceName}}</p>
                                        </td>
                                        <td class="text-center">
                                            <p>{{sharing.guessEmail}}</p>
                                        </td>
                                        <td class="text-center">
                                            <button v-if= "sharing.sharingStatus=='Activated'" type="button" class="btn btn-xs btn-success" name="button">{{ tableStatusLabelActivated[actualLanguage] }}</button>
                                            <button v-if= "sharing.sharingStatus=='Rejected'" type="button" class="btn btn-xs btn-danger" name="button">{{ tableStatusLabelRejected[actualLanguage] }}</button>
                                            <button v-if= "sharing.sharingStatus=='Pending'" type="button" class="btn btn-xs btn-info" name="button">{{ tableStatusLabelWaiting[actualLanguage] }}</button>
                                            <button v-if= "sharing.sharingStatus=='OnHold'" type="button" class="btn btn-xs btn-warning" name="button">{{ tableStatusLabelPause[actualLanguage] }}</button>
                                        </td>
                                        <td class="text-center">
                                            <div class="btn-group">
                                                <button class="btn btn-xs btn-default" type="button" @click="editSharingRulePermissions(index)" data-toggle="tooltip" title="Modifier/Edit"><i class="fa fa-pencil"></i></button>
                                                <button v-if= "sharing.sharingStatus=='Activated'" class="btn btn-xs btn-default" type="button" @click="saveSharingStatus(index,'OnHold')" data-toggle="tooltip" title="Pause"><i class="fa fa-pause"></i></button>
                                                <button v-if= "sharing.sharingStatus=='OnHold'" class="btn btn-xs btn-default" type="button" @click="saveSharingStatus(index,'Activated')" data-toggle="tooltip" title="Activer/Enable"><i class="fa fa-play"></i></button>
                                                <button class="btn btn-xs btn-default" type="button" @click="deleteSharing(index,'Deleted')" data-toggle="tooltip" title="Supprimer/Delete"><i class="fa fa-trash"></i></button>
                                            </div>
                                        </td>
                                    </tr>
                              </tbody>
                          </table>
                          </div>
                          </div>


                      </div>

                    </div>
                  </div>
                </div>
                <!-- END Sharing section -->



                <div class="col-xs-12">
                    
                    <div class="block">

                        <ul class="nav nav-tabs nav-tabs-alt nav-justified" data-toggle="tabs">


                            <li :class="{'active': tabMenuSelector[2]==true}" @click="toggleTabMenuSelector(2)">
                                <a ><i class="fa fa-server"></i> {{ tabLabelModule[actualLanguage] }}</a>
                            </li>

                            <li :class="{'active': tabMenuSelector[3]==true}" @click="toggleTabMenuSelector(3)">
                                <a ><i class="fa fa-television"></i> {{tabLabelDevice[actualLanguage] }}</a>
                            </li>

                            <li v-if="false" :class="{'active': tabMenuSelector[4]==true}" @click="toggleTabMenuSelector(4)">
                                <a ><i class="fa fa-bell"></i> {{tabLabelAlert[actualLanguage] }}</a>
                            </li>

                            <li v-if="profileData.profileConfig.displayEvConfig.value" :class="{'active': tabMenuSelector[5]==true}" @click="toggleTabMenuSelector(5)">
                                <a ><i class="fa fa-car"></i> {{ tabLabelEV[actualLanguage] }}</a>
                            </li>

                            <li v-if="flagConfigCustomDashboard" :class="{'active': tabMenuSelector[6]==true}" @click="toggleTabMenuSelector(6)">
                                <a ><i class="fa fa-dashboard"></i> {{ tabLabelCustomDashboard[actualLanguage] }}</a>
                            </li>

                        </ul>

                        <div class="block-content tab-content">


                            <div :class="{'tab-pane': true, 'active': tabMenuSelector[2]==true}" >
                                <div v-for="(device,index) in actualBundle.devices">
                                  <config-device v-if="device.DeviceData.frontendComponents.componentDeviceConfig==='EVA_V1P00'" :deviceIndex="index" ></config-device>

                                  <!-- Component for API customer devices-->
                                  <config-device-api-dev-v1p00 v-if="device.DeviceData.frontendComponents.componentDeviceConfig==='ApiDevice_V1P00'" :deviceIndex="index" ></config-device-api-dev-v1p00>

                                </div>
                                <div class="col-xs-12"><hr></hr></div>

                                
                                <p><button @click="showModal('add-device-form')" type="button" class="btn  btn-success align-left" name="button"><i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-server fa-1x push-5-r "></i>{{ labelButtonAddDevice[actualLanguage] }}</button></p>
                            </div>


                            <div :class="{'tab-pane': true, 'active': tabMenuSelector[3]==true}" >
                                <div v-if="displayChannelList===true">
                                  <config-channel-list ></config-channel-list>
                                </div>
                                <div class="col-xs-12"><hr></hr></div>
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                  <p><button @click="addChannelToBundle()" type="button" class="btn btn-success align-left" name="button">
                                    <spinner size="small" v-if="channelIsCreating"></spinner>
                                    <span v-else><i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-television fa-1x push-5-r "></i>{{ labelButtonAddChannel[actualLanguage] }}</span></button></p>
                                </div>
                            </div>

                            
                            <div v-if="false" :class="{'tab-pane': true, 'active': tabMenuSelector[4]==true}" >
                                <h4 class="font-w300 push-15">Alertes</h4>
                                <p>...</p>
                            </div>
                            


                            <div v-if="profileData.profileConfig.displayEvConfig.value" :class="{'tab-pane': true, 'active': tabMenuSelector[5]==true}" >
                                <div v-for="(car,index) in actualBundle.cars">
                                  <config-car :carIndex="index" ></config-car>
                                </div>
                                <div class="col-sm-12 col-md-12">
                                  <p><button @click="addCarToBundle()" type="button" class="btn btn-success align-left" name="button">
                                    <spinner size="small" v-if="carIsCreating"></spinner>
                                    <span v-else><i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-car fa-1x push-5-r "></i>{{ labelButtonAddCar[actualLanguage] }}</span></button></p>
                                </div>
                            </div>

                            <div :class="{'tab-pane': true, 'active': tabMenuSelector[6]==true}" >
                                <config-custom-dashboard ></config-custom-dashboard>
                            </div>

                        </div>
                    </div>
                   
                </div>


            </div>

            <div v-else >
                <div class="col-xs-12">
                    
                    <div class="block">
                        <ul class="nav nav-tabs nav-tabs-alt nav-justified" data-toggle="tabs">
                            <li v-if="actualBundleIsDefaultBundle==false" :class="{'active': tabMenuSelector[0]==true}"  @click="toggleTabMenuSelector(0)">
                                <a ><i class="fa fa-users"></i> {{tabLabelGroup[actualLanguage] }}</a>
                            </li>

                            <li :class="{'active': tabMenuSelector[1]==true}" @click="toggleTabMenuSelector(1)">
                                <a ><i class="fa fa-usb"></i> {{tabLabelSystem[actualLanguage] }}</a>
                            </li>


                            <li v-if="actualBundle.sub_bundle.length":class="{'active': tabMenuSelector[2]==true}" @click="toggleTabMenuSelector(2)">
                                <a ><i class="fa fa-usb"></i> {{tabLabelSubSystem[actualLanguage] }}</a>
                            </li>

                            <li :class="{'active': tabMenuSelector[3]==true}" @click="toggleTabMenuSelector(3)">
                                <a ><i class="fa fa-server"></i> {{tabLabelModule[actualLanguage] }}</a>
                            </li>

                            <li :class="{'active': tabMenuSelector[4]==true}" @click="toggleTabMenuSelector(4)">
                                <a ><i class="fa fa-television"></i> {{tabLabelDevice[actualLanguage] }}</a>
                            </li>

                            <li v-if="false" :class="{'active': tabMenuSelector[5]==true}" @click="toggleTabMenuSelector(5)">
                                <a ><i class="fa fa-bell"></i> {{tabLabelAlert[actualLanguage] }}</a>
                            </li>

                            <li v-if="profileData.profileConfig.displayEvConfig.value" :class="{'active': tabMenuSelector[6]==true}" @click="toggleTabMenuSelector(6)">
                                <a ><i class="fa fa-car"></i> {{tabLabelEV[actualLanguage] }}</a>
                            </li>
                        </ul>

                        <div class="block-content tab-content">

                            <div v-if="actualBundleIsDefaultBundle==false" :class="{'tab-pane': true, 'active': tabMenuSelector[0]==true }" >
                                <config-group ></config-group>
                            </div>


                            <div :class="{'tab-pane': true, 'active': tabMenuSelector[1]==true}" >
                                <config-bundle ></config-bundle>
                            </div>


                            <div :class="{'tab-pane': true, 'active': tabMenuSelector[2]==true}" >
                                <div v-for="(subBundle,index) in actualBundle.sub_bundle">
                                  <config-sub-bundle :subBundleIndex="index" ></config-sub-bundle>
                                </div>
                                <div class="col-xs-12"><hr></hr></div>
                            </div>


                            <div :class="{'tab-pane': true, 'active': tabMenuSelector[3]==true}" >

                                <div v-if="bundleConfigEditFlag" class="row">
                                  <div class="col-xs-12">
                                    <config-sharing-list  :sharingListData="{sharingType:'Device'}" ></config-sharing-list>
                                  </div>
                                </div>

                                <div v-for="(device,index) in actualBundle.devices">

                                  <config-device v-if="device.DeviceData.frontendComponents.componentDeviceConfig==='EVA_V1P00'" :deviceIndex="index" ></config-device>

                                  <!-- Component for API customer devices-->
                                  <config-device-api-dev-v1p00 v-if="device.DeviceData.frontendComponents.componentDeviceConfig==='ApiDevice_V1P00'" :deviceIndex="index" ></config-device-api-dev-v1p00>

                                </div>
                                <div class="col-xs-12"><hr></hr></div>
                                <p><button @click="showModal('add-device-form')" type="button" class="btn  btn-success align-left" name="button"><i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-server fa-1x push-5-r "></i>{{ labelButtonAddDevice[actualLanguage] }}</button></p>
                            </div>




                            <div :class="{'tab-pane': true, 'active': tabMenuSelector[4]==true}" >
                                <div v-if="displayChannelList===true">
                                  <config-channel-list ></config-channel-list>
                                </div>

                                <div class="col-xs-12"><hr></hr></div>
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                  <p><button @click="addChannelToBundle()" type="button" class="btn btn-success align-left" name="button">
                                    <spinner size="small" v-if="channelIsCreating"></spinner>
                                    <span v-else><i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-television fa-1x push-5-r "></i>{{ labelButtonAddChannel[actualLanguage] }}</span></button></p>
                                </div>
                                 
                            </div>

                            
                            <div v-if="false" :class="{'tab-pane': true, 'active': tabMenuSelector[5]==true}" >
                                <h4 class="font-w300 push-15">Alertes</h4>
                                <p>...</p>
                            </div>
                            


                            <div v-if="profileData.profileConfig.displayEvConfig.value" :class="{'tab-pane': true, 'active': tabMenuSelector[6]==true}" >
                                
                                <div v-if="bundleConfigEditFlag" class="row">
                                  <div class="col-xs-12">
                                    <config-sharing-list  :sharingListData="{sharingType:'Car'}" ></config-sharing-list>
                                  </div>
                                </div>
                                
                                <div v-for="(car,index) in actualBundle.cars">
                                  <config-car :carIndex="index" ></config-car>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-12">
                                  <p><button @click="addCarToBundle()" type="button" class="btn btn-success align-left" name="button">
                                    <spinner size="small" v-if="carIsCreating"></spinner>
                                    <span v-else><i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-car fa-1x push-5-r "></i>{{ labelButtonAddCar[actualLanguage] }}</span></button></p>
                                </div>
                            </div>

                        </div>
                    </div>
                   
                </div>

            </div>
          </div>
        </div>
      </div>

        <h6 class="font-w300 push-15"><font size="2" color="white">{{test}}</font></h6>  
      

    </div>
  </div>
</template>

<script>

import {mapState, mapActions, mapGetters} from 'vuex'
import Spinner from '@/components/Spinner'
import ConfigGroup from './ConfigGroup'
import ConfigBundle from './ConfigBundle'
import ConfigSubBundle from './ConfigSubBundle'
import ConfigDevice from './ConfigDevice'
import ConfigDeviceApiDevV1p00 from './ConfigDeviceApiDevV1p00'
import ConfigChannelList from './ConfigChannelList'
import AddDeviceForm from '@/views/configuration/AddDeviceForm'
import ConfigAlert from './ConfigAlert'
import ConfigCar from './ConfigCar'
import ConfigSharingList from './SubComponent/ConfigSharingList'
import ConfigCustomDashboard from './ConfigCustomDashboardV1p00'

export default {
  name: 'configuration',
  data() {
    return {
      actualLanguage : "FR",
      channelIsCreating : false,
      carIsCreating : false,
      labelTopPage: {FR: 'Configuration', EN: 'Configuration'},
      labelButtonAddDevice: {FR: 'Ajouter un module', EN: 'Add module'},
      labelButtonAddChannel: {FR: 'Ajouter un appareil', EN: 'Add device'},
      labelButtonAddCar: {FR: 'Ajouter un véhicule / borne', EN: 'Add vehicle / EVSE'},
      tabMenuSelector : [],
      stringBidon : '',
      displayChannelList : true,
      flagDisplaySharing : 0,
      ListOfSharings:[],
      test : 1,

      actualBundleIsDefaultBundle : true,
      bundleConfigViewFlag : false,
      bundleConfigEditFlag : false,
      bundleConfigDeleteFlag : false,
      bundleSharingEnableFlag : false,
      deviceConfigEditFlag : false,
      flagConfigCustomDashboard : false,

      sectionLabelSharing:{FR: "Partages", EN: 'Sharings'},
      buttonLabelShareMyDefaultBundle:{FR: "Partager les informations de mon système", EN: 'Share my system informations'},
      buttonLabelRefreshListSharing:{FR: "Rafraichir la liste de partages", EN: 'Refresh list of sharings'},
      textSharingDetail:{FR: "Les composantes (module, appareils et VE) sont partageables individuellement en utilisant l'icône partage de leur menu de configuration respectif. Suite a une transmission de partage, ceux-ci sont accessibles à partir du tableau affiché dans ce menu.", EN: 'Individual component sharing (module, device and EV) can be done by using the sharing icon button in respective component menu. Afterwards, sharing are acessible in the table displayed in this section.'},
      tableLabelReferenceName:{FR: "Nom de référence", EN: 'Reference name'},
      tableLabelSharingName:{FR: "Identifiant de partage", EN: 'Sharing identifier'},
      tableLabelRecipient:{FR: "Destinataire", EN: 'Recipient'},
      tableLabelStatus:{FR: "Statut", EN: 'Status'},
      tableStatusLabelActivated:{FR: "Activé", EN: 'Activated'},
      tableStatusLabelRejected:{FR: "Refusé", EN: 'Rejected'},
      tableStatusLabelWaiting:{FR: "Attente", EN: 'Pending'},
      tableStatusLabelPause:{FR: "Pause", EN: 'Standbye'},
      tabLabelGroup:{FR: "Groupe", EN: 'Group'},
      tabLabelSystem:{FR: "Système", EN: 'System'},
      tabLabelSubSystem:{FR: "Sous-Systèmes", EN: 'Sub-Systems'},
      tabLabelModule:{FR: "Module de mesure", EN: 'Monitoring module'},
      tabLabelDevice:{FR: "Appareils mesurés", EN: 'Monitored devices'},
      tabLabelAlert:{FR: "Alertes avancées", EN: 'Advance Alerts'},
      tabLabelEV:{FR: "VE/Bornes", EN: 'EV/EVSE'},
      tabLabelCustomDashboard:{FR: "Mon Dashboard", EN: 'My Dashboard'},

      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},
      messageMaxDeviceLimit:{FR: "Vous avez atteint le nombre maximale de canaux, vous devez choisir un plan de service plus élevé.", EN: 'You reach the maximum channels count, you need to upgrade your service plan.'},
      messagePromptChannelReferenceName:{FR: "Nom de référence pour cet appareil", EN: 'Reference name for this device'},
      messagePromptChannelReferenceNameTextBox:{FR: "Nom d'appareil", EN: 'Device name'},
      messageMaxEVLimit:{FR: "Vous devez avoir un module de mesure enregistré pour créer un VE ou une borne.",
                         EN: 'You must have a registered measuring module to create an EV or a charging station.'},
      messagePromptEvReferenceName:{FR: "Nom de référence pour ce VE (ou Borne)", EN: 'Reference name for this EV (or EVSE)'},
      messagePromptEVReferenceNameTextBox:{FR: "Nom de VE", EN: 'EV name'},
      messagePromptConfirmRemoveSharing:{FR: "Vous désirez effacer ce partage?", EN: 'You want to delete this sharing?'},

    }
  },
  components: {
    Spinner,
    ConfigGroup,
    ConfigBundle,
    ConfigSubBundle,
    ConfigDevice,
    ConfigDeviceApiDevV1p00,
    ConfigChannelList,
    AddDeviceForm,
    ConfigAlert,
    ConfigCar,
    ConfigSharingList,
    ConfigCustomDashboard
  },
  computed: {
    //...mapState('devicesStore',['devices', 'devicesPortData']),
    //...mapState('chargesStore',['startDate', 'endDate']),
    ...mapState('sessionStore', ['profileData','dashboardFlags','actualBundle']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

    toggleTabMenuSelector(index){
        for(var n=0;n<this.tabMenuSelector.length;n++){this.tabMenuSelector[n]=false}
        this.tabMenuSelector[index]=true
        localStorage.actualConfigTab = index

        //Comprend pas mais besoin de cette ligne pour que ca fonctionne !!
        this.test = index
    },

   toggleDisplaySharing(){
      this.readGroupSharings()
      this.flagDisplaySharing = ~this.flagDisplaySharing
    },

    addChannelToBundle(){

        var channelReferenceName = prompt(this.messagePromptChannelReferenceName[this.actualLanguage], this.messagePromptChannelReferenceNameTextBox[this.actualLanguage]);

        if(channelReferenceName != null){
            this.channelIsCreating = true
            var requestData = { 'postAction':'AddNewChannel',
                                'referenceName':channelReferenceName,
                                'bundleData':{'bundleId':this.actualBundle.bundle_id},
                                }
            this.$store.dispatch('sessionStore/postChannel', requestData)
                .then((response) => {
                  this.channelIsCreating = false
                  //console.log(response.data)
                if(response.data.Code=='OK'){
                    this.displayChannelList = false
                    //this.$store.dispatch('sessionStore/getGroupArborescence')
                    this.reloadActualBundle()
                    this.alertShowAddButton=true
                    this.displayChannelList = true
                    }
                    else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
                })
        }
        
    },

    reloadActualBundle(){

          var requestData = {'postAction':'ReadBundleData',
                            'bundleId':this.actualBundle.bundle_id}
          this.$store.dispatch('sessionStore/postBundle', requestData)
              .then((response) => {
              if(response.data.Code=='OK'){
                  //console.log('-Dashboard:loadSelectedBundle-')
                  //console.log(response.data.BundleData)
                  var bundleTempo = response.data.BundleData
                  this.$store.dispatch('sessionStore/setActualBundle', bundleTempo)
                  }
                  else{window.alert(this.messagePostFail[this.actualLanguage] )}
              })

      },


    addCarToBundle(){
        if (parseInt(this.actualBundle.devices.length * 6) <= parseInt(this.actualBundle.cars.length)){
          window.alert(this.messageMaxEVLimit[this.actualLanguage])
        }
        else{
                var carReferenceName = prompt(this.messagePromptEvReferenceName[this.actualLanguage], this.messagePromptEVReferenceNameTextBox[this.actualLanguage]);

                if(carReferenceName != null){
                    this.carIsCreating = true
                    var requestData = { 'postAction':'AddNewCar',
                                        'referenceName':carReferenceName,
                                        'bundleData':{'bundleId':this.actualBundle.bundle_id},
                                        }
                    this.$store.dispatch('sessionStore/postCar', requestData)
                        .then((response) => {
                          this.carIsCreating = false
                          //console.log(response.data)
                        if(response.data.Code=='OK'){
                            //this.$store.dispatch('sessionStore/getGroupArborescence')
                            this.$store.dispatch('sessionStore/reloadActualBundle')
                            this.alertShowAddButton=true
                            }
                            else{ window.alert(this.messagePostFail[this.actualLanguage])}
                        })
                }
        }
    },


    shareMyDefaultBundle(){
      var modalParameters = {'modalTitle':{FR: "Partage de mon système", EN: 'My System sharing'},
                        'entityOwner':this.actualBundle.bundle_id,
                        'sharingType':'Bundle',
                        'entityId':this.actualBundle.bundle_id,
                        'entityReferenceName':this.actualBundle.bundle_name,
                        'displayAlertOptions':false,
                        'displayChannelOptions':true,
                        'displayDeviceOptions':true,
                        'displayBundleOptions':true,
                        'displayGroupOptions':false,
                        'displayUserOptions':false}

      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('config-access-rules-form')
    },


    readGroupSharings(){
      var requestData = {'postAction':'GetRuleForEntity','EntityToRead':this.actualBundle.bundle_id}
      //console.log(requestData)
      this.$store.dispatch('sessionStore/postRule', requestData)
          .then((response) => {
          if(response.data.Code=='OK'){
              this.ListOfSharings = response.data.Data
              //console.log(response.data)
              }else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
          })
    },


    editSharingRulePermissions(sharingIndex){
      var modalParameters = {'ruleId':this.ListOfSharings[sharingIndex].ruleId,
                        'referenceId':this.ListOfSharings[sharingIndex].referenceId,
                        'sharingReferenceName':this.ListOfSharings[sharingIndex].sharingReferenceName,
                        'sharingGuessEmail':this.ListOfSharings[sharingIndex].guessEmail,
                        }

      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('edit-access-rules-form')
    },

    saveSharingStatus(sharingIndex,newStatus) {
        var requestData = { 'postAction':'SaveSingleRuleStatus',
                            'ruleId': this.ListOfSharings[sharingIndex].ruleId,
                            'referenceId': this.ListOfSharings[sharingIndex].referenceId,
                            'newStatus': newStatus,
                            }

        this.$store.dispatch('sessionStore/postRule', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  this.readGroupSharings()
                }
                else{ 
                  window.alert(response.data.PromptMessage[this.actualLanguage])}
            })       
      
    },

    deleteSharing(sharingIndex,newStatus) {

        if(confirm(this.messagePromptConfirmRemoveSharing[this.actualLanguage])){
          var requestData = { 'postAction':'DeleteSingleRule',
                              'ruleId': this.ListOfSharings[sharingIndex].ruleId,
                              'referenceId': this.ListOfSharings[sharingIndex].referenceId,
                              'newStatus': newStatus,
                              }

          this.$store.dispatch('sessionStore/postRule', requestData)
              .then((response) => {
              if(response.data.Code=='OK'){
                    window.alert(response.data.PromptMessage[this.actualLanguage])
                    this.readGroupSharings()
                  }
                  else{ 
                    window.alert(response.data.PromptMessage[this.actualLanguage])}
              })
        }      
      
    },


    


    findPermissionItemValue(permissionList,idToFind){
        var value = false
        for (var n = 0; n < permissionList.length; n++){
          if(permissionList[n].id == idToFind)
          {value = permissionList[n].value}
        }
        return value
    },

  },
  mounted() {
    //console.log("Measurement_Index_Mounted");
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.tabMenuSelector= [true, false, false, false, false, false]
    //console.log('-----Measurement Index Mounted-------');
    //console.log(this.profileData);
    //console.log('-------------------------');
 
    //console.log('-----Actual bundle.devices-------');
    //console.log(this.actualBundle.devices);



    //If the selected bundle if the default opened by the default user, we don't show the Group config menu
    //even in Manager version
    this.actualBundleIsDefaultBundle = this.actualBundle.bundle_id.includes('DefaultGroup::DefaultBundle')
    this.actualBundleIsDefaultBundle = this.actualBundleIsDefaultBundle & this.actualBundle.bundle_id.includes(this.profileData.profileId)

    this.bundleConfigViewFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleConfigView')
    this.bundleConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleConfigEdit')
    this.bundleConfigDeleteFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleConfigDelete')
    this.bundleSharingEnableFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleSharingEnable')
    this.deviceConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.device,'deviceConfigEdit')

    if(localStorage.actualConfigTab){
      this.toggleTabMenuSelector(localStorage.actualConfigTab)
    }else{
      this.toggleTabMenuSelector(4)
    }

    if(this.actualBundle.bundle_id.includes(':DefaultBundle')){
      this.toggleTabMenuSelector(3)
    }

    window.scrollTo(0, 0)

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tesla-bg {
  background-image: url('../../assets/configuration.png');
  min-height: 155px;
}


  .h2 {
    font-size: 26px; /* Taille de police par défaut */
  }
  .h3 {
    font-size: 20px; /* Taille de police par défaut */
  }
  .h4 {
    font-size: 16px; /* Taille de police par défaut */
  }
  .h5 {
    font-size: 16px; /* Taille de police par défaut */
  }

  /* Media Query pour les écrans de moins de 600px de large */
  @media (max-width: 600px) {

      .h2 {
          font-size: 20px; /* Taille de police réduite pour les petits écrans */
      }
      .h3 {
          font-size: 18px; /* Taille de police réduite pour les petits écrans */
      }
      .h4 {
          font-size: 12px; /* Taille de police réduite pour les petits écrans */
      }
      .h5 {
          font-size: 12px; /* Taille de police réduite pour les petits écrans */
      }
  }

</style>



// WEBPACK FOOTER //
// Index.vue?3b2cfded